import { takeEvery, put, select } from 'redux-saga/effects';
import pick from 'lodash/pick';
import companyReportsActions from '../actionTypes/companyReportsActions';
import { API_CALL } from '../actionTypes/sharedActions';
import { GET_COMPANY_REPORTS } from '../routes';
import dateTimeHelpers from '../utils/dateTimeHelpers';

const getCompanyId = (state) => {
  return state.loginReducer.currentUser.resourceable_id;
};

const getFilters = (state) => {
  return pick(state.companyReportsReducer, ['per', 'page', 'from', 'to']);
};

function* getCompanyReports({ payload }) {
  const id = yield select(getCompanyId);
  const filters = { ...(yield select(getFilters)), ...payload };

  yield put({
    type: API_CALL,
    payload: {
      url: GET_COMPANY_REPORTS.replace(':id', id),
      method: 'POST',
      data: {
        filters: {
          ...filters,
          from: dateTimeHelpers.formatDate(filters.from),
          to: dateTimeHelpers.formatDate(filters.to),
        },
      },
    },
    successAction: companyReportsActions.getCompanyReportsSuccess,
    failureAction: companyReportsActions.getCompanyReportsFailed,
  });
}

export default function* watchCompanyReports() {
  yield takeEvery(companyReportsActions.getCompanyReports, getCompanyReports);
}
